import { render, staticRenderFns } from "./xcxMessage.vue?vue&type=template&id=c1d74538&scoped=true"
import script from "./xcxMessage.vue?vue&type=script&lang=js"
export * from "./xcxMessage.vue?vue&type=script&lang=js"
import style0 from "./xcxMessage.vue?vue&type=style&index=0&id=c1d74538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d74538",
  null
  
)

export default component.exports